import { createAsyncLocalStorage } from "./async-local-storage";
export const actionAsyncStorage = createAsyncLocalStorage();

//# sourceMappingURL=action-async-storage.external.js.map